const data = {
  title: "Floor 2-5",
  musicTrack: "MUSIC_WORLD2",
  theme: "GREEN",
  tilesWidth: 11,
  tilesHeight: 7,
  placements: [
    {
      type: "HERO_SPAWN",
      x: 2,
      y: 4,
    },
    {
      type: "PLACEMENT_TYPE_GOAL",
      x: 10,
      y: 4,
    },
    {
      type: "WATER",
      x: 5,
      y: 4,
    },
    {
      type: "WATER",
      x: 4,
      y: 4,
    },
    {
      type: "WATER",
      x: 5,
      y: 3,
    },
    {
      type: "WATER",
      x: 6,
      y: 3,
    },
    {
      type: "WATER",
      x: 6,
      y: 4,
    },
    {
      type: "WATER",
      x: 6,
      y: 5,
    },
    {
      type: "WATER",
      x: 7,
      y: 4,
    },
    {
      type: "CHIP",
      x: 6,
      y: 4,
    },
    {
      type: "WATER",
      x: 8,
      y: 4,
    },
    {
      type: "WATER",
      x: 7,
      y: 3,
    },
    {
      type: "WATER",
      x: 6,
      y: 2,
    },
    {
      type: "WATER",
      x: 5,
      y: 5,
    },
    {
      type: "WATER",
      x: 6,
      y: 6,
    },
    {
      type: "WATER",
      x: 7,
      y: 5,
    },
    {
      type: "ENEMY_SPAWN",
      x: 10,
      y: 2,
      direction: "LEFT",
      enemyType: "ENEMY",
    },
    {
      type: "WATER_PICKUP",
      x: 10,
      y: 6,
    },
  ],
};

export default data;
